import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_AuthLayout = _resolveComponent("AuthLayout")!

  return (_openBlock(), _createBlock(_component_AuthLayout, {
    icon: "fas fa-sign-in-alt",
    eyebrow: "Welkom bij Simplex Flow",
    title: "Inloggen",
    description: "Je logt in met je account van de Simplex AppStore. Daarna kom je direct terug in Flow."
  }, {
    default: _withCtx(() => [
      _createVNode(_component_NButton, {
        class: "auth-submit",
        tag: "a",
        href: "https://app.simplexconnect.nl",
        type: "primary",
        size: "large",
        "icon-placement": "right"
      }, {
        icon: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1)
        ]))]),
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createTextVNode("Inloggen via de Simplex AppStore", -1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}